export interface IJobEducation1 {
    personid?: string
    education?: string
    NameOfInstitute?: string
    major?: string
    graduate?: string
    FromMonthYear?: string
    ToMonthYear?: string
    gpa?: string
    seq?: string
    educationOther?: string
}

export interface IJobEducation2Language {
    language?: string
    file1?: string
    speaking?: string
    understanding?: string
    reading?: string
    writting?: string
    seq?: string
}

export interface IJobEducation2Training {
    training_subject?: string
    training_institute?: string
    training_period?: string
    seq?: string
}
export interface IJobEducation3 {
    personid?: string
    licenses?: IJobEducation3License[]
}
export interface IJobEducation3License {
    license_name?: string
    license_no?: string
    license_date?: string
    seq?: string
}
export interface IJobEducation2 {
    personid?: string
    language_edus2?: IJobEducation2Language[]
    training_edus2?: IJobEducation2Training[]
}
export interface IJobFamily {
    personid?: string
    family?: IJobRegisterFamily
    childs?: IJobChild[]
    brother_sisters?: IJobBrotherSister[]
}
export interface IJobRegisterFamily {

    MaritalStatus?: string
    married_year?: string
    NumberChildren?: string
    age?: string
    f_title?: string
    f_fname?: string
    f_lname?: string
    f_age?: string
    f_occupation?: string
    f_address?: string
    f_tel?: string
    m_title?: string
    m_fname?: string
    m_lname?: string
    m_age?: string
    m_occupation?: string
    m_address?: string
    m_tel?: string
    b_title?: string
    b_fname?: string
    b_lname?: string
    b_age?: string
    b_occupation?: string
    b_address?: string
    b_tel?: string
    urgent_title?: string
    urgent_fname?: string
    urgent_lname?: string
    urgent_tel?: string
    urgent_address?: string
    urgent_relation?: string
    s_title?: string
    s_fname?: string
    s_lname?: string
    s_age?: string
    s_occupation?: string
    s_address?: string
    s_tel?: string

}

export interface IJobChild {
    seq?: string
    title?: string
    fname?: string
    lname?: string
    age?: string
    occupation?: string
    address?: string
    tel?: string

}

export interface IJobBrotherSister {
    b_title?: string
    b_fname?: string
    b_lname?: string
    b_age?: string
    b_occupation?: string
    b_address?: string
    b_tel?: string
    seq?: string
}
export interface IJobExpJob {
    personid?: string
    hiring_date?: string
    hobby?: string
    last_jobs?: IJobExpLastJob[]
}
export interface IJobExpLastJob {
    lastjob_from?: string
    lastjob_to?: string
    lastjob_company?: string
    lastjob_position?: string
    lastjob_start_salary?: string
    lastjob_end_salary?: string
    lastjob_descript?: string
    lastjob_leaving?: string
    resume?: string
    seq?: string
    yearType?: string
    file_type?:string
}
export interface IJobExpInfo{
    personid?:string
    flag_illegal?:boolean
    illegal_remark?:string
    flag_NotPerfect?:boolean
    NotPerfect_remark?:string
    flag_sack?:boolean
    sack_remark?:string
    flag_WorkWithAsset?:boolean
    WorkWithAsset_reamrk?:string
    flag_confirm?:string
    hasCar?:boolean
    hasMotorcycle?:boolean
    driverLicenseType?:string
    employment?:string
    employee?:string
    aboutYourself?:string
    flag_pdpa?:boolean
    refs?:IJobExpInfoRef[]
}
export interface IJobExpInfoRef
{
    ref_title?:string
    ref_fname?:string
    ref_lname?:string
    ref_position?:string
    ref_tel?:string
    ref_relation?:string
    seq?:string
}
export interface RequestAnswerUHNW {
    customerid: Number
    type:String
    QuestionId: Number[]
}


export enum DriverLicenseType {
    NONE = "NONE",
    TEMPORARILY = "TEMPORARILY",
    PERMANENT = "PERMANENT",
    ALL = "ALL",
  }

  export enum EmploymentType {
    ONEAM = "ONEAM",
    AGENT = "AGENT",
    EMPLOYEE = "EMPLOYEE",
  }
  export interface IFileUpload
{
    base64?:string
    file_type?:string
}

export interface RequestKaDetail {
    Customerid: Number
    KnowledgeId: Number
}